import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/privacy/page.tsx");
